"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountInfoReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var AccountInfoAction_1 = require("@/pages/accountInfo/actions/AccountInfoAction");
var AccountInfoState_init_1 = require("@/pages/accountInfo/states/AccountInfoState.init");
exports.accountInfoReducer = function (state, action) {
    if (state === void 0) { state = AccountInfoState_init_1.defaultAccountInfoState; }
    switch (action.type) {
        case typesafe_actions_1.getType(AccountInfoAction_1.default.setIsEditing): {
            return __assign(__assign({}, state), { isEditing: action.payload });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onSalutationChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { salutation: action.payload }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onFirstNameChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { firstname: action.payload }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onLastNameChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { lastname: action.payload }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onEmailChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { email: action.payload }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onPhoneBodyChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { phone: __assign(__assign({}, state.account.phone), { body: "" + action.payload }) }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onPhoneCodeChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { phone: __assign(__assign({}, state.account.phone), { code: "" + action.payload }) }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onBirthdayDayChanged): {
            var newDate = new Date(state.account.birthdayDate);
            newDate.setDate(action.payload);
            var newBirthdayStr = newDate.getFullYear() + "/" + (newDate.getMonth() + 1) + "/" + newDate.getDate();
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { birthdayDate: newBirthdayStr }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onBirthdayMonthChanged): {
            var newDate = new Date(state.account.birthdayDate);
            newDate.setMonth(action.payload);
            var newBirthdayStr = newDate.getFullYear() + "/" + (newDate.getMonth() + 1) + "/" + newDate.getDate();
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { birthdayDate: newBirthdayStr }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onBirthdayYearChanged): {
            var newDate = new Date(state.account.birthdayDate);
            newDate.setFullYear(action.payload);
            var newBirthdayStr = newDate.getFullYear() + "/" + (newDate.getMonth() + 1) + "/" + newDate.getDate();
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { birthdayDate: newBirthdayStr }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onLanguageChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { language: action.payload }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.onCurrencyChanged): {
            return __assign(__assign({}, state), { account: __assign(__assign({}, state.account), { currency: action.payload }) });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.setErrors): {
            return __assign(__assign({}, state), { errors: action.payload });
        }
        case typesafe_actions_1.getType(AccountInfoAction_1.default.setServerErrors): {
            return __assign(__assign({}, state), { serverErrors: action.payload });
        }
    }
    return state;
};
